import {AElement} from "./AElement";
import {EElementType} from "../utils/EElementType";
import ModelsRegExp from "../../services/ModelsRegExp";

export class Mast extends AElement {

    constructor(serialNumber: string, isScanned?: boolean) {
        super(EElementType.Mast, serialNumber, isScanned, ModelsRegExp.elementSerialNumberMast);
    }

    public static remapObjectToElement(object: any): Mast | null {
        let element: Mast | null = null;
        if(
            object._serialNumber
        ) {
            element = new Mast(
                object._serialNumber,
                object._isScanned
            );
        }
        return element;
    }

}


